var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapPinWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1846 6.66663C14.1846 11.3333 8.18457 15.3333 8.18457 15.3333C8.18457 15.3333 2.18457 11.3333 2.18457 6.66663C2.18457 5.07533 2.81671 3.5492 3.94193 2.42399C5.06715 1.29877 6.59327 0.666626 8.18457 0.666626C9.77587 0.666626 11.302 1.29877 12.4272 2.42399C13.5524 3.5492 14.1846 5.07533 14.1846 6.66663Z",
    stroke: "#0B0B0D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18457 8.66663C9.28914 8.66663 10.1846 7.7712 10.1846 6.66663C10.1846 5.56206 9.28914 4.66663 8.18457 4.66663C7.08 4.66663 6.18457 5.56206 6.18457 6.66663C6.18457 7.7712 7.08 8.66663 8.18457 8.66663Z",
    stroke: "#0B0B0D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinWhite);
export default __webpack_public_path__ + "static/media/map-pin-white.7079bb26.svg";
export { ForwardRef as ReactComponent };